import {useDebounceFn} from 'ahooks';
import {Form, Input, Select} from 'antd';
import {FormulaTreeChartReportPage} from 'holo-api';
import {useEffect} from 'react';

import {ActifSelectorOptions} from './shared/reportInterfaces';
import {RichTextEditor, TemplateTag} from './shared/RichTextEditor';

interface FormulaTreeFormType {
  title: string;
  subTitle?: string;
  formId?: number;
}

export const FormulaTreeChart = ({
  index,
  chartPage,
  setChartPage,
  actifSelectorOptions,
  templateTags,
}: {
  index: number;
  chartPage: FormulaTreeChartReportPage;
  setChartPage: (page: FormulaTreeChartReportPage) => void;
  actifSelectorOptions: ActifSelectorOptions;
  templateTags: Array<TemplateTag>;
}) => {
  const [form] = Form.useForm<FormulaTreeFormType>();

  useEffect(() => {
    form.setFieldsValue({
      title: chartPage.title,
      subTitle: chartPage.subTitle,
      formId: chartPage.formId,
    });
  }, [form, chartPage]);

  const {run: onChangedPage} = useDebounceFn(
    async (values: FormulaTreeFormType) => {
      try {
        const validated = await form.validateFields();
        const newChartPage: FormulaTreeChartReportPage = {...chartPage};
        newChartPage.title = validated.title;
        newChartPage.subTitle = validated.subTitle;
        newChartPage.formId = validated.formId;
        setChartPage(newChartPage);
      } catch (err) {
        console.warn('onChangedPage', values);
        console.error('Not a valid form', err);
      }
    },
    {wait: 500},
  );

  const onRichTextChanged = (richText: string) => {
    const newChart = {...chartPage};
    newChart.richExplain = richText;
    setChartPage(newChart);
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column'}}>
      <div>
        <Form
          form={form}
          onValuesChange={(_changedValues, values) => onChangedPage(values)}
        >
          <Form.Item label="Titre" name="title">
            <Input />
          </Form.Item>
          <Form.Item label="Sous Titre" name="subTitle">
            <Input />
          </Form.Item>

          <Form.Item label="Formulaire" name="formId">
            <Select
              style={{width: '100%'}}
              options={actifSelectorOptions}
              placeholder="Recherche de formulaire"
            />
          </Form.Item>
        </Form>
      </div>
      <div style={{flex: 1}}>
        <RichTextEditor
          uniqueId={`page_${index}`}
          richText={chartPage.richExplain ?? ''}
          setRichText={onRichTextChanged}
          templateTags={templateTags}
        ></RichTextEditor>
      </div>
    </div>
  );
};
